import * as Types from '../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CallGroupListFragment = { __typename?: 'Group', id: number, name: string, number?: { __typename?: 'Number', e164?: any | null, shortNumber?: string | null } | null };

export type CallQueueListFragment = { __typename?: 'Group', id: number, name: string, number?: { __typename?: 'Number', shortNumber?: string | null } | null };

export type CreateCallGroupMutationVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
  type: Types.CallGroupType;
  name: Types.Scalars['String']['input'];
  shortNumber: Types.Scalars['String']['input'];
  e164?: Types.InputMaybe<Types.Scalars['String']['input']>;
  pickup?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  sequentialTimeout?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  size?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  members?: Types.InputMaybe<Array<Array<Types.CreateCallGroupMember>>>;
}>;


export type CreateCallGroupMutation = { __typename?: 'Mutation', createCallGroup: { __typename?: 'SaveResult', id?: number | null, errors?: Array<{ __typename?: 'Error', location: Array<string>, context?: string | null, type: string }> | null } };

export type UpdateCallGroupMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
  name?: Types.InputMaybe<Types.Scalars['String']['input']>;
  type?: Types.InputMaybe<Types.CallGroupType>;
  pickup?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  sequentialTimeout?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  outgoingCallBarringOperator?: Types.InputMaybe<Array<Types.InputMaybe<Types.OutgoingCallBarring>>>;
  outgoingCallBarringAdmin?: Types.InputMaybe<Array<Types.InputMaybe<Types.OutgoingCallBarring>>>;
  size?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type UpdateCallGroupMutation = { __typename?: 'Mutation', updateCallGroup?: { __typename?: 'SaveResult', errors?: Array<{ __typename?: 'Error', location: Array<string>, context?: string | null, type: string }> | null } | null };

export type DomainAllocationInfoFragment = { __typename?: 'DomainAllocationInfo', domainAllocated: number, domainUsed: number, remaining: number, allocationIncrementError?: { __typename?: 'Error', type: string, context?: string | null } | null };

export type CallGroupLimitForAllSizesQueryVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
}>;


export type CallGroupLimitForAllSizesQuery = { __typename?: 'Query', domainAllocation: { __typename?: 'DomainAllocations', services: { __typename?: 'ServiceDomainAllocationsInfo', group5: { __typename?: 'DomainAllocationInfo', domainAllocated: number, domainUsed: number, remaining: number, allocationIncrementError?: { __typename?: 'Error', type: string, context?: string | null } | null }, group10: { __typename?: 'DomainAllocationInfo', domainAllocated: number, domainUsed: number, remaining: number, allocationIncrementError?: { __typename?: 'Error', type: string, context?: string | null } | null }, group20: { __typename?: 'DomainAllocationInfo', domainAllocated: number, domainUsed: number, remaining: number, allocationIncrementError?: { __typename?: 'Error', type: string, context?: string | null } | null } } } };

export type CallGroupMembersQueryVariables = Types.Exact<{
  groupId: Types.Scalars['Int']['input'];
}>;


export type CallGroupMembersQuery = { __typename?: 'Query', groups?: { __typename?: 'GroupList', items: Array<{ __typename?: 'Group', id: number, groupType: Types.GroupType, numberId: number, hasAddressBook: boolean, name: string, number?: { __typename?: 'Number', domain: { __typename?: 'Domain', name: string } } | null, members: Array<{ __typename?: 'GroupMembership', numberId: number, callOrder?: number | null, sectionIndex: number, controllingLine: boolean, allowEditAddressBook: boolean, number?: { __typename?: 'Number', shortNumber?: string | null, extension?: { __typename?: 'User', displayName: string, alternateCallerNumberId?: number | null } | null } | null }> } | null> } | null };

export type ExtensionListQueryVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
}>;


export type ExtensionListQuery = { __typename?: 'Query', users?: { __typename?: 'UserList', items: Array<{ __typename?: 'User', id: number, displayName: string, numberId: number, number?: { __typename?: 'Number', shortNumber?: string | null } | null } | null> } | null, usersCapabilities?: Array<{ __typename?: 'UserCapabilities', id?: number | null, capabilities?: Array<Types.Capability | null> | null } | null> | null };

export type CallGroupRelatedDataQueryVariables = Types.Exact<{
  groupId: Types.Scalars['Int']['input'];
}>;


export type CallGroupRelatedDataQuery = { __typename?: 'Query', relatedData: { __typename?: 'References', gateways: Array<{ __typename?: 'Gateway', id: number, displayName: string, number?: { __typename?: 'Number', shortNumber?: string | null } | null }>, overrideCaller: Array<{ __typename?: 'User', id: number, displayName: string, number?: { __typename?: 'Number', id: number, shortNumber?: string | null } | null }>, ivrActions: Array<{ __typename?: 'IvrAction', id: number, button: number, ivrProfile?: { __typename?: 'IvrProfile', name: string, ivr?: { __typename?: 'Ivr', id: number, name: string, number?: { __typename?: 'Number', shortNumber?: string | null } | null } | null } | null }>, phoneButtons: Array<{ __typename?: 'BasePhoneButton', id: number, speedDialNumber?: string | null, buttonPosition: number, device?: { __typename?: 'Device', id: number, extensionId: number, extension?: { __typename?: 'User', displayName: string, numberId: number, number?: { __typename?: 'Number', shortNumber?: string | null } | null } | null } | null }> } };

export type GetNewTargetsQueryVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
}>;


export type GetNewTargetsQuery = { __typename?: 'Query', gateways?: { __typename?: 'GatewayList', items: Array<{ __typename?: 'Gateway', id: number, displayName: string, number?: { __typename?: 'Number', id: number, shortNumber?: string | null } | null } | null> } | null, faxes?: { __typename?: 'FaxList', items: Array<{ __typename?: 'Fax', id: number, number?: { __typename?: 'Number', id: number, shortNumber?: string | null } | null } | null> } | null, groups?: { __typename?: 'GroupList', items: Array<{ __typename?: 'Group', id: number, number?: { __typename?: 'Number', id: number, shortNumber?: string | null } | null } | null> } | null, users?: { __typename?: 'UserList', items: Array<{ __typename?: 'User', id: number, displayName: string, number?: { __typename?: 'Number', id: number, shortNumber?: string | null } | null } | null> } | null, ivrs?: { __typename?: 'IvrList', items: Array<{ __typename?: 'Ivr', name: string, number?: { __typename?: 'Number', id: number, shortNumber?: string | null } | null } | null> } | null };

export const CallGroupListFragmentDoc = gql`
    fragment CallGroupList on Group {
  id
  name
  number {
    e164
    shortNumber
  }
}
    `;
export const CallQueueListFragmentDoc = gql`
    fragment CallQueueList on Group {
  id
  name
  number {
    shortNumber
  }
}
    `;
export const DomainAllocationInfoFragmentDoc = gql`
    fragment DomainAllocationInfo on DomainAllocationInfo {
  domainAllocated
  domainUsed
  remaining
  allocationIncrementError {
    type
    context
  }
}
    `;
export const CreateCallGroupDocument = gql`
    mutation CreateCallGroup($domainId: Int!, $type: CallGroupType!, $name: String!, $shortNumber: String!, $e164: String, $pickup: Boolean, $sequentialTimeout: Int, $size: Int, $members: [[CreateCallGroupMember!]!]) {
  createCallGroup(
    domainId: $domainId
    type: $type
    name: $name
    shortNumber: $shortNumber
    size: $size
    e164: $e164
    pickup: $pickup
    sequentialTimeout: $sequentialTimeout
    members: $members
  ) {
    id
    errors {
      location
      context
      type
    }
  }
}
    `;
export type CreateCallGroupMutationFn = Apollo.MutationFunction<CreateCallGroupMutation, CreateCallGroupMutationVariables>;

/**
 * __useCreateCallGroupMutation__
 *
 * To run a mutation, you first call `useCreateCallGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCallGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCallGroupMutation, { data, loading, error }] = useCreateCallGroupMutation({
 *   variables: {
 *      domainId: // value for 'domainId'
 *      type: // value for 'type'
 *      name: // value for 'name'
 *      shortNumber: // value for 'shortNumber'
 *      e164: // value for 'e164'
 *      pickup: // value for 'pickup'
 *      sequentialTimeout: // value for 'sequentialTimeout'
 *      size: // value for 'size'
 *      members: // value for 'members'
 *   },
 * });
 */
export function useCreateCallGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateCallGroupMutation, CreateCallGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCallGroupMutation, CreateCallGroupMutationVariables>(CreateCallGroupDocument, options);
      }
export type CreateCallGroupMutationHookResult = ReturnType<typeof useCreateCallGroupMutation>;
export type CreateCallGroupMutationResult = Apollo.MutationResult<CreateCallGroupMutation>;
export type CreateCallGroupMutationOptions = Apollo.BaseMutationOptions<CreateCallGroupMutation, CreateCallGroupMutationVariables>;
export const UpdateCallGroupDocument = gql`
    mutation UpdateCallGroup($id: Int!, $name: String, $type: CallGroupType, $pickup: Boolean, $sequentialTimeout: Int, $outgoingCallBarringOperator: [OutgoingCallBarring], $outgoingCallBarringAdmin: [OutgoingCallBarring], $size: Int) {
  updateCallGroup(
    id: $id
    name: $name
    type: $type
    pickup: $pickup
    sequentialTimeout: $sequentialTimeout
    outgoingCallBarringOperator: $outgoingCallBarringOperator
    outgoingCallBarringAdmin: $outgoingCallBarringAdmin
    size: $size
  ) {
    errors {
      location
      context
      type
    }
  }
}
    `;
export type UpdateCallGroupMutationFn = Apollo.MutationFunction<UpdateCallGroupMutation, UpdateCallGroupMutationVariables>;

/**
 * __useUpdateCallGroupMutation__
 *
 * To run a mutation, you first call `useUpdateCallGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCallGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCallGroupMutation, { data, loading, error }] = useUpdateCallGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      type: // value for 'type'
 *      pickup: // value for 'pickup'
 *      sequentialTimeout: // value for 'sequentialTimeout'
 *      outgoingCallBarringOperator: // value for 'outgoingCallBarringOperator'
 *      outgoingCallBarringAdmin: // value for 'outgoingCallBarringAdmin'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useUpdateCallGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCallGroupMutation, UpdateCallGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCallGroupMutation, UpdateCallGroupMutationVariables>(UpdateCallGroupDocument, options);
      }
export type UpdateCallGroupMutationHookResult = ReturnType<typeof useUpdateCallGroupMutation>;
export type UpdateCallGroupMutationResult = Apollo.MutationResult<UpdateCallGroupMutation>;
export type UpdateCallGroupMutationOptions = Apollo.BaseMutationOptions<UpdateCallGroupMutation, UpdateCallGroupMutationVariables>;
export const CallGroupLimitForAllSizesDocument = gql`
    query CallGroupLimitForAllSizes($domainId: Int!) {
  domainAllocation(domainId: $domainId) {
    services {
      group5 {
        ...DomainAllocationInfo
      }
      group10 {
        ...DomainAllocationInfo
      }
      group20 {
        ...DomainAllocationInfo
      }
    }
  }
}
    ${DomainAllocationInfoFragmentDoc}`;

/**
 * __useCallGroupLimitForAllSizesQuery__
 *
 * To run a query within a React component, call `useCallGroupLimitForAllSizesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCallGroupLimitForAllSizesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCallGroupLimitForAllSizesQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useCallGroupLimitForAllSizesQuery(baseOptions: Apollo.QueryHookOptions<CallGroupLimitForAllSizesQuery, CallGroupLimitForAllSizesQueryVariables> & ({ variables: CallGroupLimitForAllSizesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CallGroupLimitForAllSizesQuery, CallGroupLimitForAllSizesQueryVariables>(CallGroupLimitForAllSizesDocument, options);
      }
export function useCallGroupLimitForAllSizesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CallGroupLimitForAllSizesQuery, CallGroupLimitForAllSizesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CallGroupLimitForAllSizesQuery, CallGroupLimitForAllSizesQueryVariables>(CallGroupLimitForAllSizesDocument, options);
        }
export function useCallGroupLimitForAllSizesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CallGroupLimitForAllSizesQuery, CallGroupLimitForAllSizesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CallGroupLimitForAllSizesQuery, CallGroupLimitForAllSizesQueryVariables>(CallGroupLimitForAllSizesDocument, options);
        }
export type CallGroupLimitForAllSizesQueryHookResult = ReturnType<typeof useCallGroupLimitForAllSizesQuery>;
export type CallGroupLimitForAllSizesLazyQueryHookResult = ReturnType<typeof useCallGroupLimitForAllSizesLazyQuery>;
export type CallGroupLimitForAllSizesSuspenseQueryHookResult = ReturnType<typeof useCallGroupLimitForAllSizesSuspenseQuery>;
export type CallGroupLimitForAllSizesQueryResult = Apollo.QueryResult<CallGroupLimitForAllSizesQuery, CallGroupLimitForAllSizesQueryVariables>;
export const CallGroupMembersDocument = gql`
    query CallGroupMembers($groupId: Int!) {
  groups(id: $groupId) {
    items {
      id
      groupType
      numberId
      hasAddressBook
      name
      number {
        domain {
          name
        }
      }
      members {
        numberId
        callOrder
        sectionIndex
        controllingLine
        allowEditAddressBook
        number {
          shortNumber
          extension {
            displayName
            alternateCallerNumberId
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCallGroupMembersQuery__
 *
 * To run a query within a React component, call `useCallGroupMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCallGroupMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCallGroupMembersQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useCallGroupMembersQuery(baseOptions: Apollo.QueryHookOptions<CallGroupMembersQuery, CallGroupMembersQueryVariables> & ({ variables: CallGroupMembersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CallGroupMembersQuery, CallGroupMembersQueryVariables>(CallGroupMembersDocument, options);
      }
export function useCallGroupMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CallGroupMembersQuery, CallGroupMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CallGroupMembersQuery, CallGroupMembersQueryVariables>(CallGroupMembersDocument, options);
        }
export function useCallGroupMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CallGroupMembersQuery, CallGroupMembersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CallGroupMembersQuery, CallGroupMembersQueryVariables>(CallGroupMembersDocument, options);
        }
export type CallGroupMembersQueryHookResult = ReturnType<typeof useCallGroupMembersQuery>;
export type CallGroupMembersLazyQueryHookResult = ReturnType<typeof useCallGroupMembersLazyQuery>;
export type CallGroupMembersSuspenseQueryHookResult = ReturnType<typeof useCallGroupMembersSuspenseQuery>;
export type CallGroupMembersQueryResult = Apollo.QueryResult<CallGroupMembersQuery, CallGroupMembersQueryVariables>;
export const ExtensionListDocument = gql`
    query ExtensionList($domainId: Int!) {
  users(domainId: $domainId) {
    items {
      id
      displayName
      numberId
      number {
        shortNumber
      }
    }
  }
  usersCapabilities(domainId: $domainId) {
    id
    capabilities
  }
}
    `;

/**
 * __useExtensionListQuery__
 *
 * To run a query within a React component, call `useExtensionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useExtensionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExtensionListQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useExtensionListQuery(baseOptions: Apollo.QueryHookOptions<ExtensionListQuery, ExtensionListQueryVariables> & ({ variables: ExtensionListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExtensionListQuery, ExtensionListQueryVariables>(ExtensionListDocument, options);
      }
export function useExtensionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExtensionListQuery, ExtensionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExtensionListQuery, ExtensionListQueryVariables>(ExtensionListDocument, options);
        }
export function useExtensionListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExtensionListQuery, ExtensionListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExtensionListQuery, ExtensionListQueryVariables>(ExtensionListDocument, options);
        }
export type ExtensionListQueryHookResult = ReturnType<typeof useExtensionListQuery>;
export type ExtensionListLazyQueryHookResult = ReturnType<typeof useExtensionListLazyQuery>;
export type ExtensionListSuspenseQueryHookResult = ReturnType<typeof useExtensionListSuspenseQuery>;
export type ExtensionListQueryResult = Apollo.QueryResult<ExtensionListQuery, ExtensionListQueryVariables>;
export const CallGroupRelatedDataDocument = gql`
    query CallGroupRelatedData($groupId: Int!) {
  relatedData(id: $groupId, numberType: GROUP) {
    gateways {
      id
      displayName
      number {
        shortNumber
      }
    }
    overrideCaller {
      id
      displayName
      number {
        id
        shortNumber
      }
    }
    ivrActions {
      id
      button
      ivrProfile {
        name
        ivr {
          id
          name
          number {
            shortNumber
          }
        }
      }
    }
    phoneButtons {
      id
      speedDialNumber
      buttonPosition
      device {
        id
        extensionId
        extension {
          displayName
          numberId
          number {
            shortNumber
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCallGroupRelatedDataQuery__
 *
 * To run a query within a React component, call `useCallGroupRelatedDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useCallGroupRelatedDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCallGroupRelatedDataQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useCallGroupRelatedDataQuery(baseOptions: Apollo.QueryHookOptions<CallGroupRelatedDataQuery, CallGroupRelatedDataQueryVariables> & ({ variables: CallGroupRelatedDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CallGroupRelatedDataQuery, CallGroupRelatedDataQueryVariables>(CallGroupRelatedDataDocument, options);
      }
export function useCallGroupRelatedDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CallGroupRelatedDataQuery, CallGroupRelatedDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CallGroupRelatedDataQuery, CallGroupRelatedDataQueryVariables>(CallGroupRelatedDataDocument, options);
        }
export function useCallGroupRelatedDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CallGroupRelatedDataQuery, CallGroupRelatedDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CallGroupRelatedDataQuery, CallGroupRelatedDataQueryVariables>(CallGroupRelatedDataDocument, options);
        }
export type CallGroupRelatedDataQueryHookResult = ReturnType<typeof useCallGroupRelatedDataQuery>;
export type CallGroupRelatedDataLazyQueryHookResult = ReturnType<typeof useCallGroupRelatedDataLazyQuery>;
export type CallGroupRelatedDataSuspenseQueryHookResult = ReturnType<typeof useCallGroupRelatedDataSuspenseQuery>;
export type CallGroupRelatedDataQueryResult = Apollo.QueryResult<CallGroupRelatedDataQuery, CallGroupRelatedDataQueryVariables>;
export const GetNewTargetsDocument = gql`
    query GetNewTargets($domainId: Int!) {
  gateways(domainId: $domainId) {
    items {
      id
      displayName
      number {
        id
        shortNumber
      }
    }
  }
  faxes(domainId: $domainId) {
    items {
      id
      number {
        id
        shortNumber
      }
    }
  }
  groups(domainId: $domainId) {
    items {
      id
      number {
        id
        shortNumber
      }
    }
  }
  users(domainId: $domainId) {
    items {
      id
      displayName
      number {
        id
        shortNumber
      }
    }
  }
  ivrs(domainId: $domainId) {
    items {
      name
      number {
        id
        shortNumber
      }
    }
  }
}
    `;

/**
 * __useGetNewTargetsQuery__
 *
 * To run a query within a React component, call `useGetNewTargetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewTargetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewTargetsQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useGetNewTargetsQuery(baseOptions: Apollo.QueryHookOptions<GetNewTargetsQuery, GetNewTargetsQueryVariables> & ({ variables: GetNewTargetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNewTargetsQuery, GetNewTargetsQueryVariables>(GetNewTargetsDocument, options);
      }
export function useGetNewTargetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNewTargetsQuery, GetNewTargetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNewTargetsQuery, GetNewTargetsQueryVariables>(GetNewTargetsDocument, options);
        }
export function useGetNewTargetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNewTargetsQuery, GetNewTargetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNewTargetsQuery, GetNewTargetsQueryVariables>(GetNewTargetsDocument, options);
        }
export type GetNewTargetsQueryHookResult = ReturnType<typeof useGetNewTargetsQuery>;
export type GetNewTargetsLazyQueryHookResult = ReturnType<typeof useGetNewTargetsLazyQuery>;
export type GetNewTargetsSuspenseQueryHookResult = ReturnType<typeof useGetNewTargetsSuspenseQuery>;
export type GetNewTargetsQueryResult = Apollo.QueryResult<GetNewTargetsQuery, GetNewTargetsQueryVariables>;